module.exports = __webpack_public_path__ + "static/turtle-creek-house15-6552e8647ac91e4f4f855f2faf52bca6.jpg";